"use client"

import { Text } from "@chakra-ui/react"
import { Box } from "@chakra-ui/react/box"
import { Flex } from "@chakra-ui/react/flex"
import { LinkBox, LinkOverlay } from "@chakra-ui/react/link"
import { HStack, VStack } from "@chakra-ui/react/stack"

import MarkdownParser from "@/components/MarkdownParser"
import { Education } from "@/types/getAbout"
import { GlobeIcon, MapPinIcon } from "@/components/icons"

interface AccordionEducationContentProps {
  education: Education
}

const AccordionEducationContent = ({
  education,
}: AccordionEducationContentProps) => {
  return (
    <VStack
      alignItems="stretch"
      borderColor={"border.muted"}
      borderTopWidth="1px"
      paddingLeft={4}
      paddingRight={4}
    >
      <HStack
        borderBottomWidth="1px"
        borderColor="border.muted"
        justifyContent={"space-between"}
        marginBottom={2}
        my={2}
        paddingBottom={2}
      >
        <LinkBox
          _hover={{
            _dark: {
              borderColor: "primary.300",
            },
            borderColor: "primary.500",
          }}
          borderBottomWidth="1px"
          borderColor={"transparent"}
        >
          <LinkOverlay
            _dark={{
              color: "primary.300",
            }}
            alignContent="center"
            alignItems="center"
            color="primary.500"
            display={"flex"}
            flexDirection="row"
            flexWrap="wrap"
            href={education.company.url}
            justifyContent="flex-start"
            padding="0"
            rel="noopener"
            title={education.company.name + " Current Website"}
          >
            <Text color={"currentColor"} fontSize="xs">
              Website
            </Text>
            <Box color={"currentColor"} display="inline-flex" marginLeft={1}>
              <GlobeIcon boxSize="12px" />
            </Box>
          </LinkOverlay>
        </LinkBox>

        <Flex gap={1}>
          <Flex alignItems="center">
            <Text
              alignItems={"center"}
              color="fg.muted"
              display={"inline-flex"}
              fontSize="xs"
              marginRight={1}
            >
              <MapPinIcon boxSize="12px" style={{ marginRight: "4px" }} />
              {education.location}
            </Text>
          </Flex>
        </Flex>
      </HStack>
      <VStack
        alignItems="flex-start"
        color={"fg"}
        css={{
          "& > p": {
            color: "currentColor",
            fontSize: "0.75rem",
          },
        }}
        pb={4}
      >
        {education.role_description !== undefined && (
          <MarkdownParser
            fontSize="sm"
            marginBottom={"0.5rem"}
            markdown={education.role_description}
          />
        )}
      </VStack>
    </VStack>
  )
}

export default AccordionEducationContent
